module.exports = __webpack_public_path__ + "img/captchaModal.3135361f.png";